import createComponent from '../create-component';
export default createComponent([["title",{"key":"svg-title"}],["g",{"clip-path":"url(#rss3-vsl_svg__a)","key":"svg-g"}],["defs",{"key":"svg-defs"}]]);